export default __webpack_public_path__ + "static/media/promo-gift.69e914eb.svg";